import { render, staticRenderFns } from "./ai-greeting.vue?vue&type=template&id=9db4028e&scoped=true"
import script from "./ai-greeting.vue?vue&type=script&lang=js"
export * from "./ai-greeting.vue?vue&type=script&lang=js"
import style0 from "./ai-greeting.vue?vue&type=style&index=0&id=9db4028e&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9db4028e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/AI合规前端-测试/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9db4028e')) {
      api.createRecord('9db4028e', component.options)
    } else {
      api.reload('9db4028e', component.options)
    }
    module.hot.accept("./ai-greeting.vue?vue&type=template&id=9db4028e&scoped=true", function () {
      api.rerender('9db4028e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/taxLaw/home/chat/ai-greeting.vue"
export default component.exports